import { CSSObject } from "styled-components";

const cssObjectForPrimaryState = (
	backgroundColorHex: string | undefined,
	colorHex: string | undefined,
	svgFillHex?: string
): CSSObject => {
	return {
		backgroundColor: backgroundColorHex,
		border: "none",
		".Typography": {
			color: colorHex,
		},
		".Icon svg": {
			fill: svgFillHex || colorHex,
		},
	};
};

export default cssObjectForPrimaryState;
